import { IImpersonatedUser } from './types';

export const getRedirectPath = (impersonatedUser?: IImpersonatedUser) => {
  if (!impersonatedUser) {
    return '/';
  } else if (impersonatedUser.isAdmin) {
    return '/dashboard';
  } else {
    return '/learning';
  }
};
